<template>
<body>
  <div>
    <div class="container2">
      <div class="question">Diese Organisation neigt dazu, sich an vielen Regeln und Verfahren zu orientieren, die festlegen, wie verschiedene Aspekte einer Aufgabe zu erledigen sind.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="struktur" @input="update" />
      <span :style="warning()" class="rangeValue"> {{struktur}} </span></div>
    </div>

    <div class="container2">
      <div class="question">Es können nur wenige Maßnahmen ergriffen werden, bevor das Management diese genehmigt hat.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="struktur2" @input="update2" />
      <span :style="warning2()" class="rangeValue"> {{struktur2}} </span></div>
    </div>

    <div class="container2">
      <div class="question">Unsere Strategieentwicklung sucht aktiv nach Informationen/ Erkenntnissen aus dem gesamten Unternehmen.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="struktur3" @input="update3" />
      <span :style="warning3()" class="rangeValue"> {{struktur3}} </span></div>
    </div>

    <div class="container2">
      <div class="question">Unsere Organisationsstruktur wird tendenziell, nach strategischen Entscheidungen häufig angepasst und weiterentwickelt.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="struktur4" @input="update4" />
      <span :style="warning4()" class="rangeValue"> {{struktur4}} </span></div>
    </div>


    <div class="container3">
      <button class="button_save" @click="evaluateForm">auswerten</button>
    </div>


  </div>

</body>    
</template>

<script>
  export default {
    props: ["StrukturValue", "StrukturValue2", "StrukturValue3", "StrukturValue4", "StrukturValue5", "StrukturValue6"],
    data(){
      return {
        struktur: this.StrukturValue,
        struktur2: this.StrukturValue2,
        struktur3: this.StrukturValue3,
        struktur4: this.StrukturValue4,
        struktur5: this.StrukturValue5,
        struktur6: this.StrukturValue6
      }
    },
    methods: {   
      update(a){
        this.struktur = a.target.value
      },
      update2(b){
        this.struktur2 = b.target.value
      },
      update3(c){
        this.struktur3 = c.target.value
      },
      update4(d){
        this.struktur4 = d.target.value
      },
      update5(e){
        this.struktur5 = e.target.value
      },
      update6(f){
        this.struktur6 = f.target.value
      },
      warning:function(){
        if(this.struktur == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.struktur == 4)
          return{
            color: "#A1A250",
          }
        if (this.struktur == 3)
          return{
            color: "#E09A34",
          }
        if (this.struktur == 2)
          return{
            color: "#E87735",
          }
        if (this.struktur == 1)
          return{
            color: "#F44336",
          }

      },
      warning2:function(){
        if(this.struktur2 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.struktur2 == 4)
          return{
            color: "#A1A250",
          }
        if (this.struktur2 == 3)
          return{
            color: "#E09A34",
          }
        if (this.struktur2 == 2)
          return{
            color: "#E87735",
          }
        if (this.struktur2 == 1)
          return{
            color: "#F44336",
          }

      },
      warning3:function(){
        if(this.struktur3 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.struktur3 == 4)
          return{
            color: "#A1A250",
          }
        if (this.struktur3 == 3)
          return{
            color: "#E09A34",
          }
        if (this.struktur3 == 2)
          return{
            color: "#E87735",
          }
        if (this.struktur3 == 1)
          return{
            color: "#F44336",
          }

      },
      warning4:function(){
        if(this.struktur4 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.struktur4 == 4)
          return{
            color: "#A1A250",
          }
        if (this.struktur4 == 3)
          return{
            color: "#E09A34",
          }
        if (this.struktur4 == 2)
          return{
            color: "#E87735",
          }
        if (this.struktur4 == 1)
          return{
            color: "#F44336",
          }

      },
      warning5:function(){
        if(this.struktur5 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.struktur5 == 4)
          return{
            color: "#A1A250",
          }
        if (this.struktur5 == 3)
          return{
            color: "#E09A34",
          }
        if (this.struktur5 == 2)
          return{
            color: "#E87735",
          }
        if (this.struktur5 == 1)
          return{
            color: "#F44336",
          }

      },
      warning6:function(){
        if(this.struktur6 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.struktur6 == 4)
          return{
            color: "#A1A250",
          }
        if (this.struktur6 == 3)
          return{
            color: "#E09A34",
          }
        if (this.struktur6 == 2)
          return{
            color: "#E87735",
          }
        if (this.struktur6 == 1)
          return{
            color: "#F44336",
          }

      },
      
      evaluateForm(){
        if (this.struktur==null) {
          this.struktur='3' 
        } 
        if (this.struktur2==null) {
          this.struktur2='3'
        } 
        if (this.struktur3==null) {
          this.struktur3='3'
        } 
        if (this.struktur4==null) {
          this.struktur4='3'
        } 
        if (this.struktur5==null) {
          this.struktur5='3'
        } 
        if (this.struktur6==null) {
          this.struktur6='3'
        }

        this.$emit('update:StrukturValue', this.struktur)
        this.$emit('update:StrukturValue2', this.struktur2)
        this.$emit('update:StrukturValue3', this.struktur3)
        this.$emit('update:StrukturValue4', this.struktur4)
        this.$emit('update:StrukturValue5', this.struktur5)
        this.$emit('update:StrukturValue6', this.struktur6)
        this.$emit('saved')
      }
    }
  };
</script>

@keyframes anim {
  0%{
    right: -20px;
  }
  25%{
    right: -10px
  }
  50%{
    right: -30px
  }
  70%{
    right: -10px
  }
  100%{
    right: -20px

  }
}


<style>
body{
  margin: 0;
  padding: 0;
  background-color: #fff;
}

.container2{
  position: relative;
  height: 50 px;
  width: 600px;
  margin: 50px auto;
}
.question{
  position: relative;
  width: 600px;
  margin: 10px auto;
  padding: 10px 10px;
}

.slider{
  position: relative;
  width: 600px;
  margin: 10px auto;
  padding: 10px 10px;
}

.container2 .mySlider {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 400px;
  height: 25px;
  background-color: #F5F5F5;
  border-radius: 20px;
  outline:none;
  opacity: 0.7;
  transition: opacity .2s ease-in;
  -webkit-transition: opacity .2s ease-in;

}

.container2 .mySlider:hover{
  opacity: 1;
}

.container2 .mySlider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #F5F5F5;
  cursor: pointer;
  -webkit-transition: all .3s ease-in;
  transition: all .3s ease-in;
  border: 2px solid #F5F5F5;

}

.container2 .mySlider::moz-slider-thumb {
  -moz-appearance: none;
  appearance: none;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #F5F5F5;
  cursor: pointer;
  -webkit-transition: all .3s ease-in;
  transition: all .3s ease-in;
  border: 2px solid #F5F5F5;

}

.container2 .mySlider::-webkit-slider-thumb:hover {
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.5)
}
.container2 .rangeValue {
  position: absolute;
  height: 40px;
  width: 60px;
  right: -20px;
  top: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid #fff;
  color: #fff;
  font-weight: 600;
  font-family: 'Karla', Arial, Helvetica, sans-serif;
  text-align: center;
  line-height: 38px;
  font-size: 22px;
}

.container2 .rangeValue::before {
  position: absolute;
  content: "";
  height: 10px;
  width: 10px;
  background-color: #2f3640;
  top: 14px;
  left: -6px;
  border-top: 1px solid transparent;
  border-bottom: 1px solid #fff;
  border-left: 1px solid #fff;
  border-right: 1px solid transparent;
  transform: rotate(45deg);
}

.container3 {
  height: 40px;
  width: 150px;
  margin: 20px auto;
  justify-content: center;
}

.button_save {
  font-size: 15px;
  height: 40px;
  width: 130px;
  background-color: #0A2342;
  margin: 0px 10px;
  border-color: #00FFFF;
  color:aliceblue;
  justify-content: center;
  font-family: 'Poppins', 'Arial Black', Gadget, sans;

}

@keyframes anim {
  0%{
    right: -20px;
  }
  25%{
    right: -10px
  }
  50%{
    right: -30px
  }
  70%{
    right: -10px
  }
  100%{
    right: -20px

  }
}



</style>